import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { bindQueryCacheToSession } from "./lib/api/queryCacheIdentity";
import { initTelemetry } from "./lib/telemetry/posthog";
import "./styles/fonts.css";
import "./styles/tokens.css";
import "./styles/dashboard.css";
import "./styles/auth.css";
import "./styles/admin.css";
import "./styles/calendar.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Dashboard data is read-heavy and refreshed manually — long
      // staleTime keeps the UI snappy and avoids re-fetch storms on
      // tab focus when the gerente switches between screens.
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
bindQueryCacheToSession(queryClient);

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element #root not found in index.html");
}

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
);

initTelemetry();
